import { Component } from '@angular/core'
import { GoBackComponent } from '../components/go-back/go-back.component'
import { RouterOutlet } from '@angular/router'

@Component({
   selector: 'app-pages',
   standalone: true,
   imports: [GoBackComponent, RouterOutlet],
   templateUrl: './pages.component.html',
   // this host adds a 'contents' class, which more or less hides the element from the CSS hierarchy, making the flex box thing work ¯\_(ツ)_/¯
   // eslint-disable-next-line @angular-eslint/no-host-metadata-property
   host: {
      class: 'contents'
   }
})
export class PagesComponent {

}
